export class SubgroupModel {
  subgroupId: number = 0;
  code: string = '';
  name: string = '';
  groupId: number = 0;
  createDate: string = "";
  userNameCreate: string = "";
  updateDate: string | null = null;
  userNameUpdate: string | null = null;
}
